import { useMediaQuery } from '../hooks/useMediaQuery';

export const useIsMobile = () => useMediaQuery('(max-width: 640px)');
export const useIsTablet = () =>
  useMediaQuery('(min-width: 720px) and (max-width: 1120px)');
export const useIsDesktop = () => useMediaQuery('(min-width: 1120px)');
